export default __webpack_public_path__ + "static/media/chevron_rightV2.2f9badea.svg";